import { BaseParameterDto } from './base-parameter-dto';

export class QuickPaymentPropertiesParameterDto extends BaseParameterDto {
  customerId: string; //16 character starts with "R"

  constructor(customerId?: string) {
    super();
    this.customerId = customerId;
  }

  override getQueryString(): string {
    return `?customerId=${this.customerId}&clearCache=${this.clearCache}`;
  }
}
